/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

// Flare实时表现预览 http://wiki.xunlei.cn/pages/viewpage.action?pageId=174042330
export const SaadaFlareHomopage = createAsyncThunk(
  'Saada/SaadaFlare/live/hiya_socialize/flare_rt_preview',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/hiya_socialize/flare_rt_preview',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data
  }
)

export enum FlareTypeEnum {
  中级 = 0,
  高级 = 1,
  特级 = 2,
  中级福利 = 3,
  高级福利 = 4,
}

const initialState: {
  home?: Partial<{
    type: FlareTypeEnum
    title: string
    desc: string
    used_seconds: number
    max_used_seconds: number
    stat: {
      total_viewers: number // 总观看数（对应int64类型）
      on_mic_users: number // 在麦上的用户数（对应int64类型）
      message_senders: number // 消息发送人数（对应int64类型）
      room_followers: number // 关注房间的用户数（对应int64类型）
      gift_users: number // 送礼人数（对应int64类型）
      pearl_count: number // 珍珠数（对应int64类型）
      bet_uv: number // 下注人数（对应int64类型）
      bet_coins: number // 下注金额（对应int64类型）
    }
    status: 0 | 1 // 0 使用中 1已结束
  }>
} = {
  home: {
    // test: 'ttt',
    // num: 12345,
  },
}

export function useSaadaFlare() {
  return useSelector((store) => store.SaadaFlare)
}

export const SaadaFlareSlice = createSlice({
  name: 'SaadaFlare',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(SaadaFlareHomopage.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state, {home: data})
    })
  },
})

export default SaadaFlareSlice.reducer
export const SaadaFlareActions = SaadaFlareSlice.actions
